export function isString(o?: any): o is string {
    return typeof o === 'string';
}
